export const ADVERTISERS_BULK_UNLINK_SELECTED_COUNT = 'ADVERTISERS:TABLE:BULK_UNLINK:SELECTED_COUNT'
export const ADVERTISERS_BULK_UNLINK_CANCEL_LABEL = 'ADVERTISERS:TABLE:BULK_UNLINK:CANCEL_LABEL'
export const ADVERTISERS_BULK_UNLINK_SEND_LABEL = 'ADVERTISERS:TABLE:BULK_UNLINK:SEND_LABEL'
export const ADVERTISERS_BULK_UNLINK_LOADING_LABEL = 'ADVERTISERS:TABLE:BULK_UNLINK:LOADING_LABEL'
export const ADVERTISERS_BULK_UNLINK_MODAL_HEADER = 'ADVERTISERS:TABLE:BULK_UNLINK:MODAL_HEADER'
export const ADVERTISERS_BULK_UNLINK_MESSAGE_LABEL = 'ADVERTISERS:TABLE:BULK_UNLINK:MESSAGE_LABEL'
export const ADVERTISERS_BULK_UNLINK_CLEAR_LABEL = 'ADVERTISERS:TABLE:BULK_UNLINK:CLEAR_LABEL'
export const ADVERTISERS_BULK_UNLINK_HEADER = 'ADVERTISERS:TABLE:BULK_UNLINK:HEADER'
export const NO_ADVERTISERS_DATA_HEADER = 'ADVERTISERS:NO_DATA:HEADER'
export const NO_ADVERTISERS_DATA_BODY = 'ADVERTISERS:NO_DATA:BODY'
export const NO_ADVERTISERS_RESULTS_HEADER = 'ADVERTISERS:NO_RESULTS:HEADER'
export const NO_ADVERTISERS_RESULTS_BODY = 'ADVERTISERS:NO_RESULTS:BODY'
export const ADVERTISERS_ERROR_HEADER = 'ADVERTISERS:TABLE:ERROR_HEADER'
export const ADVERTISERS_ERROR_MESSAGE = 'ADVERTISERS:TABLE:ERROR_MESSAGE'
export const ADVERTISERS_ERROR_CALL_TO_ACTION = 'ADVERTISERS:TABLE:ERROR_CALL_TO_ACTION'
export const TABLE_HEADER_ACTION = 'ADVERTISERS:TABLE:HEADER:ACTION'
export const TABLE_HEADER_ACCOUNT = 'ADVERTISERS:TABLE:HEADER:ACCOUNT'
export const TABLE_HEADER_TYPE = 'ADVERTISERS_V2:TABLE:HEADER:TYPE'
export const TABLE_HEADER_ACCESS_LEVEL = 'ADVERTISERS_V2:TABLE:HEADER:ACCESS_LEVEL'
export const TABLE_HEADER_INFO_TIP_ACCESS_LEVEL = 'ADVERTISERS:TABLE:HEADER:INFO_TIP:ACCESS_LEVEL'
